import { Visible } from "../../util/enhancer";

type WrapperProps = {
  children?: React.ReactNode;
};

const Wrapper = ({ children }: WrapperProps) => <>{children}</>;

const VisibleSection = Visible(Wrapper);

export { VisibleSection };
